import script from "./BannerLinkEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerLinkEditor.vue?vue&type=script&setup=true&lang=js"

import "./BannerLinkEditor.vue?vue&type=style&index=0&id=2ea30efd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ea30efd"]])

export default __exports__